import React, { useState } from 'react';
import { Button } from 'primereact/button';
import {  FaFileAlt} from "react-icons/fa";
import { Carousel } from 'primereact/carousel';
import { Dialog } from 'primereact/dialog';
import { baseURL } from '../../../api';
import './ListeServices.css';
import { Card } from 'primereact/card';
import { resolveServicePhoto } from '../../utils/utils/resolveServicePhoto';
  // import NousContacterDevis from '../../DemandeDevisService/demandeDevisService';
import NousContacter from '../../NousContacterService/nousContacter';

import { useQuery } from 'react-query';
import fetchTypeService from "../../../Data/typeService_service"
import fetchlivrableByActif from '../../../Data/livrable_service';
import { useService } from '../../../Context/ServiceContext'
import { useActif} from '../../../Context/ActifContext';
import { useLivrable } from '../../../Context/LivrableContext';
export default function ListeServices() {   

    const [openDialogContact, setDialog] = useState(false);
    const {setServiceAttributes, service,  setSelectedService}=useService()
    const {selectedActif} = useActif()
    const{setLivrableAttributes, livrable}=useLivrable()
  
   useQuery( 'serviceData',  () => fetchTypeService(setServiceAttributes))
   console.log('services liste :' , service)
  useQuery( ['livrableData', selectedActif],  () => fetchlivrableByActif(setLivrableAttributes, selectedActif)
   ,  {
     enabled: !!selectedActif, // Enable the query only if selectedClient is truthy

     onSuccess: () => {
       // This will be called after successful refetch
       setLivrableAttributes({});
     },
   }
   );
  
   let services= Object.values(service)
   let livrables= Object.values(livrable)
   

   let livrableService = {};
   services?.forEach((service) => (livrableService[service.libelle] = []));
   services?.map((service) => {
     return livrables?.forEach((livrable) => {
       if (livrable.id_type_service_gexpertise === service.id_type_service_gexpertise) {
        livrableService[service.libelle].push(livrable);
       }
     });
   });
   
   const livrableParService = Object.entries(livrableService).map((item) => {
    const [key, value] = item;
    return {
      name: key,
      value: value,
    };
  });
//    console.log("livrableParSErvice key :: " , livrableParService)

    const responsiveOptions = [
      {
        breakpoint: '2000px',
        numVisible: 3,
        numScroll: 1
    },
    {
      breakpoint: '1400px',
      numVisible: 2,
      numScroll: 1
  },
  {
      breakpoint: '1199px',
      numVisible: 1,
      numScroll: 1
  },
  {
      breakpoint: '767px',
      numVisible: 1,
      numScroll: 1
  },
  {
      breakpoint: '575px',
      numVisible: 1,
      numScroll: 1
  }

    ];

    // const livrables = [...dataTable].sort((a, b) =>   b.value.length - a.value.length);
    const productTemplate = (ser  ,index) => {
        const imgSrc = resolveServicePhoto(baseURL, ser.photo);

        return (
            <div key={index}>
            { 
                    livrableParService.map((L , k )=>(
                      
                            L.name === ser.libelle ?
                    <div className="border-1 surface-border border-round m-2 text-center py-3 px-3 serviceBox" key={k}>
                   
                    <div className="imageService" >
                  
                        <img src={imgSrc} alt={ser.libelle} className="shadow-2 img-fluid" style={{width: "200px" , height:"150px"}}/>
                    </div>
                   
                    <div className='serviceLibelle'>
                        <h6 style={{fontSize:'14px',whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                          {ser.libelle.split(" ").slice(0, 3).join(" ")}</h6>
                        <p className="descriptionService">{ser.description}</p>
                        <div className="mt-5 flex flex-wrap gap-2 justify-content-center">
                            <Button icon="pi pi-envelope" className="p-button service-btn" label="Nous contacter" 
                            onClick={(e)=> {
                                setDialog(true); 
                                setSelectedService(ser)
                                
                            }
                            }  />
                            
                        </div>
                    </div> 

                </div> : ""
            ))}
            </div>
        );
    };
    return (

   <>
<div className="cardService">
<Card > 
<h5>Services proposés par le groupe Gexpertise </h5>
            <Carousel value={services} numScroll={1} numVisible={3}   responsiveOptions={responsiveOptions}
            className="custom-carousel" 
            circular
            autoplayInterval={6000}
            itemTemplate={productTemplate} 
            />
           
          
</Card>
  <Dialog header="Contactez-nous" visible={openDialogContact} style={{ width: '50vw' }} onHide={() => setDialog(false)} >
                <NousContacter setDialog={setDialog}  />
            </Dialog>
        </div> 
   
    
    
 {/* <Dialog header="Contactez-nous" visible={openDialogContact} style={{ width: '50vw' }} onHide={() => setDialogContact(false)} >
    <NousContacter setDialog={setDialogContact} nomService={nomService} typeServiceId={typeServiceId} idActif={idActif} />
</Dialog>
*/}
   </>
    )


}